import { Decimal } from 'decimal.js'
import { clamp } from "@/lib/prelude.js";

const bounded = (min, max) => op => op(min, max);
const set = (count, delta) => (min, max) => clamp(count + delta, min, max);

//+ T -> Counted<T>
const Counted = i => ({ count: 0, item: i })

//+ Counted<T> -> number
const count = c => c.count

//+ Counted<T> -> T
const e = c => c.item

//+ [T] -> [Counted<T>]
const many = l => l.map(e => Counted(e))

//+ [T] -> (T -> str) -> { str: Counted<T> }
const mapped = (l,n) => l.reduce((a, e) => { a[n(e)] = Counted(e); return a }, {})

const unkey = ([,b]) => b
const filter = f => mapped => Object.entries(mapped).map(unkey).filter(f)
const selected = filter(b => b.count > 0)

const totalize = ({ count, item }) => new Decimal(count).mul(new Decimal(item.price))

const showCompte = v => `${v.count} ${v.item.nom}`

//+ { str: Counted<T> } -> number
const mappedCompte = mapped => Object.entries(mapped)
      .map(([,v]) => v.count)
      .reduce((a,b) => a+b)

//+ { str: Counted<T> }  -> string
const shortCounted = (b, sep=', ') => selected(b).map(showCompte).join(sep)

/**
const showNomsC = (items, sep=",") => Object.entries(items)
      .map(([,v]) => v)
      .filter(v => v.count > 0)
      .map(v => `${v.count} ${v.item.nom}`)
      .join(sep)
**/

export { bounded, set, Counted, count, e, many, mapped, unkey, filter, selected, totalize, showCompte, mappedCompte, shortCounted };
